import parse from "html-react-parser";
import React, { useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useRouteError, useRouteLoaderData } from "react-router-dom";

import { url_reverse } from "@components/Utils";

function ErrorPage() {
    const { t } = useTranslation();
    const [more, setMore] = useState(null);
    const error = useRouteError();
    const commonInfo = useRouteLoaderData("commonInfo");
    return (
        <Container fluid className="my-3">
            <Row className="flex-xl-nowrap">
                <Col>
                    <Card className="w-75 mx-auto">
                        <Card.Header>{t("Ошибка")}</Card.Header>
                        <Card.Body>
                            {parse(error.message.replace(/\n/g, "<br>"))}
                            <br />
                            <small>
                                {more ? (
                                    <>
                                        URL: {window.location.href}
                                        <br />
                                        LOGIN: {commonInfo?.account?.login}
                                        <br />
                                        <br />
                                        {more}
                                    </>
                                ) : (
                                    <a
                                        href="#"
                                        onClick={(ev) => {
                                            ev.preventDefault();
                                            setMore(error.stack);
                                        }}
                                    >
                                        {t("Детали")}
                                    </a>
                                )}
                            </small>
                        </Card.Body>
                        <Card.Footer>
                            <Link to={url_reverse("games:list")}>{t("На главную")}</Link>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default ErrorPage;
